import React, { useEffect, useState, useRef } from "react";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";

const socket = new BuddibleSocket();

const _mClassName = "PopupMain";
const today = new Date();
let isMobileBack = false;
let loginInfo = null;

export default function PopupMain() {
  const [isShow, setIsShow] = useState(true);
  const [isMobile, setIsMobile] = useState(false); //760 이하를 모바일로봄
  const closeToday = useRef();
  const closeWeek = useRef();

  useEffect(() => {
    isMobileCheck();
    window.addEventListener("resize", isMobileCheck);

    let userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      loginInfo = userData["returnData"][0];
    }
    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          loginInfo = n["returnData"][0];
        }
      }
    );

    return () => {
      window.removeEventListener("resize", isMobileCheck);
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  const isMobileCheck = () => {
    let windowWidth = window.innerWidth;
    let check = windowWidth <= 760;
    if (isMobileBack !== check) {
      isMobileBack = check;
      setIsMobile(check);
    }
  };

  const FncDisableDateSet = (addDate = 0) => {
    let setDate = today.getDate() + addDate;
    let disableDate = new Date();
    disableDate.setDate(setDate);
    disableDate = disableDate.toLocaleDateString();
    return disableDate;
  };

  const popupClose = () => {
    if (closeToday.current.checked) {
      let disableDate = FncDisableDateSet(1);
      localStorage.setItem("PopupMain", disableDate);
    }

    if (closeWeek.current.checked) {
      let disableDate = FncDisableDateSet(7);
      localStorage.setItem("PopupMain", disableDate);
    }

    setIsShow(false);
  };

  return (
    <>
      {isShow && (
        <div
          className="position-absolute shadow border rounded text-white NNS"
          style={{
            maxWidth: 440,
            ...(isMobile
              ? {
                  top: 80,
                  left: 0,
                }
              : { top: 80, left: 200 }),
            zIndex: 99,
          }}
        >
          <div className="position-relative bg-white" style={{ zIndex: 999 }}>
            <div className="px-3 pt-2 position-absolute" style={{ right: 0 }}>
              <div className="text-right">
                <span
                  className="h4 font-weight-bold mb-0 cursor_pointer text-white"
                  onClick={() => popupClose()}
                >
                  &times;
                </span>
              </div>
            </div>
            <a
              className="position-absolute text-white"
              href="https://www.newsian.co.kr/news/articleView.html?idxno=81383"
              target="_blank"
              style={{
                top: "79%",
                left: "50%",
                transform: "translateX(-50%)",
                translate: ".3",
              }}
            >
              뉴스 바로가기 →
            </a>
            <img src="/img/main/popup/zimsync_apec.png" width={"100%"} />
            <div className="checkboxes bg-white text-dark p-2 d-flex flex-row justify-content-end border-top position-relative">
              <label
                className="container_check mb-0 d-flex flex-row align-items-center mr-2"
                htmlFor="fregiscopLaunchingInput1"
              >
                일주일간 열지 않기
                <input
                  id="fregiscopLaunchingInput1"
                  className="form-check-input"
                  type="checkbox"
                  ref={closeWeek}
                />{" "}
                <span className="checkmark" />
              </label>
              <label
                className="container_check mb-0 d-flex flex-row align-items-center"
                htmlFor="fregiscopLaunchingInput2"
              >
                오늘하루 열지 않기
                <input
                  id="fregiscopLaunchingInput2"
                  className="form-check-input"
                  type="checkbox"
                  ref={closeToday}
                />{" "}
                <span className="checkmark" />
              </label>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
